import { JsonObject, JsonProperty } from 'json2typescript';
import { DocumentRefDataInterface } from '../interfaces/document-ref-data.interface';

@JsonObject('DocumentRefData')
export class DocumentRefData implements DocumentRefDataInterface {
  Categories?: Category[];
  Elements?: Element[];
  Modules?: Module[];

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Category')
export class Category {
  DefaultModuleId?: string;
  FolderName?: string;
  Id?: string;
  Name?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Element')
export class Element {
  ElementCode?: string;
  ElementId?: string;
  ElementType?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}

@JsonObject('Module')
export class Module {
  Id?: string;
  Name?: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
